import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
import newsletterImage1 from '../assets/careers/newsletter-image-1.jpg';
import newsletterImage2 from '../assets/careers/newsletter-image-2.jpg';

const CareersNewsletterSection: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Placeholder for newsletter subscription - can integrate with backend later
    console.log('Subscribe:', email);
    setEmail('');
  };

  return (
    <section className="relative bg-[#fafafb] py-16 lg:py-20 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative bg-[#ffad0a] rounded-[20px] p-12 lg:p-16 max-w-[960px] mx-auto"
          style={{ height: '238px' }}
        >
          {/* Decorative Images */}
          <div className="absolute right-0 top-[-47px] hidden lg:block">
            {/* Image 1 */}
            <div className="absolute right-[187px] top-[6px] w-[242px] h-[279px] rounded-tl-[28px] rounded-tr-[28px] overflow-hidden">
              <img
                src={newsletterImage1}
                alt=""
                className="w-full h-full object-cover"
                style={{ height: '103.23%', left: '-9.5%', top: '-1.43%', width: '119.01%' }}
              />
            </div>
            {/* Image 2 */}
            <div className="absolute right-[193px] top-0 w-[250px] h-[285px] rounded-[8px] overflow-hidden">
              <img
                src={newsletterImage2}
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
            {/* Send Button Icon */}
            <div className="absolute right-[449px] top-[86px] w-[52px] h-[52px] bg-brand-blue rounded-[26px] flex items-center justify-center">
              <Send className="w-6 h-6 text-white" />
            </div>
          </div>

          {/* Content */}
          <div className="relative z-10">
            <h2 className="font-open-sans font-bold text-[32px] leading-[48px] text-white mb-4" style={{ fontVariationSettings: "'wdth' 100" }}>
              Looking for something
            </h2>
            <p className="font-open-sans font-normal text-[16px] leading-[26px] text-white mb-8" style={{ fontVariationSettings: "'wdth' 100" }}>
              Subscribe to our newsletter
            </p>

            {/* Email Form */}
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-[#fff8eb] text-[#ffba30] font-manrope font-normal text-[16px] leading-[26px] px-4 py-2.5 rounded-lg placeholder:text-[#ffba30] focus:outline-none focus:ring-2 focus:ring-white focus:border-white"
                style={{ height: '43px' }}
                required
              />
              <button
                type="submit"
                className="bg-brand-blue text-white font-manrope font-normal text-[16px] leading-[26px] px-6 py-2.5 rounded-lg hover:bg-brand-blue-700 transition-colors"
                style={{ height: '44px', width: '107px' }}
              >
                Subscribe
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CareersNewsletterSection;
